import actionTypes from '../actionTypes';

export function requestUnreadMessages() {
    return {
        type: actionTypes.GET_UNREAD_MESSAGES_REQUEST
    };
}

export function requestAllMessages(clubId) {
    return {
        type: actionTypes.GET_MESSAGES_REQUEST,
        clubId
    };
}

export function successMessages(arrMessages) {
    return {
        type: actionTypes.GET_UNREAD_MESSAGES_SUCCESS,
        arrMessages
    };
}

export function successAllMessages(arrMessages) {
    return {
        type: actionTypes.GET_MESSAGES_SUCCESS,
        arrMessages
    };
}

export function openMessage (messageId) {
    return {
        type: actionTypes.OPEN_MESSAGE,
        messageId
    }
}

export function closeMessage (messageId) {
    return {
        type: actionTypes.CLOSE_MESSAGE,
        messageId
    }
}

export function closePopUpMessage (messageId) {
    return {
        type: actionTypes.CLOSE_POP_UP_MESSAGE,
        messageId
    }
}

export function requestReadMessage ( {messageId, accountId} ) {
    return {
        type: actionTypes.READ_MESSAGE_REQUEST,
        messageId,
        accountId
    }
}

export function successReadMessage ({messageId, accountId}) {
    return {
        type: actionTypes.READ_MESSAGE_SUCCESS,
        messageId,
        accountId
    }
}

export function requestSendMessage ( {clubId, title, content} ) {
    return {
        type: actionTypes.SEND_MESSAGE_REQUEST,
        clubId,
        title,
        content
    }
}
export function successSendMessage () {
    return {
        type: actionTypes.SEND_MESSAGE_SUCCESS
    }
}

export function setCountOfUnreadMessages ( count ) {
    return {
        type: actionTypes.SET_UNREAD_MESSAGES_COUNT,
        count
    }
}

export function setOpenedMessage (message) {
    return {
        type: actionTypes.SET_OPENED_MESSAGE,
        message
    }
}

export function closeOpenedMessage () {
    return {
        type: actionTypes.CLOSE_OPENED_MESSAGE
    }
}

export function requestDeleteMessages ( messageIds ) {
    return {
        type: actionTypes.DELETE_MESSAGE_REQUEST,
        messageIds
    }
}

export function successDeleteMessage () {
    return {
        type: actionTypes.DELETE_MESSAGE_SUCCESS
    }
}
// export function openMessages () {
//     return {
//         type: actionTypes.OPEN_MESSAGES
//     }
// };

// export function closeMessages () {
//     return {
//         type: actionTypes.CLOSE_MESSAGES
//     }
// };
